import { commonTypes } from '../common';

const types = {
  SET_SELECTED_MOBILE_LINE: 'APISNEEDS/SET_SELECTED_MOBILE_LINE',
};

export const initialState = {
  fundingInfo: {
    selectedMobileLine: null,
    selectedFundingOffer: null,
  },
  vtlDataForConfirmation: {},
};

const ApisNeedsVTLReducer = (state, action) => {
  switch (action.type) {
    case types.SET_SELECTED_MOBILE_LINE: {
      const { selectedMobileLine } = action.payload;
      const { number } = selectedMobileLine;
      return {
        ...state,
        fundingInfo: {
          ...state.fundingInfo,
          selectedMobileLine: number,
        },
      };
    }
    case commonTypes.SET_VTL_DATA_FOR_CONFIRMATION: {
      const { vtlDataForConfirmation } = action.payload;
      const { terminalData } = vtlDataForConfirmation;
      return {
        ...state,
        vtlDataForConfirmation: {
          ...state.vtlDataForConfirmation,
          terminalData,
        },
      };
    }
    case commonTypes.SET_SELECTED_FUNDING_OFFER: {
      const {
        selectedFundingOffer,
      } = action.payload;

      return {
        ...state,
        fundingInfo: {
          ...state.fundingInfo,
          selectedFundingOffer,
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setSelectedMobileLine: selectedMobileLine => ({
    type: types.SET_SELECTED_MOBILE_LINE,
    payload: {
      selectedMobileLine,
    },
  }),
  setVtlDataForConfirmation: vtlDataForConfirmation => ({
    type: commonTypes.SET_VTL_DATA_FOR_CONFIRMATION,
    payload: {
      vtlDataForConfirmation,
    },
  }),
};

export default ApisNeedsVTLReducer;
